export default __webpack_public_path__ + "static/media/un.4f542f50.jpg";